module.exports = __webpack_public_path__ + "static/media/PitchHub-help.98f17d8a.svg";